import { Link, LinkProps } from "@mui/material";
import React, { ReactEventHandler, Ref, forwardRef } from "react";

interface IListLinkValueProps extends LinkProps {
    inactive?: boolean;
}

const getPropsWithoutInactive = (props: IListLinkValueProps): LinkProps => {
    const { inactive, ...rest } = props;
    return rest;
};

const ListLinkValue = forwardRef(
    (
        props: IListLinkValueProps,
        ref: Ref<HTMLButtonElement>
    ) => (
        <Link
            component="button"
            sx={{
                maxWidth: "100%",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                textDecoration: "underline" + (props.inactive ? " line-through" : "")
            }}
            onClick={props.onClick as unknown as ReactEventHandler<HTMLButtonElement>}
            ref={ref}
            {...getPropsWithoutInactive(props)}
        >
            {props.children}
        </Link>
    )
);

ListLinkValue.displayName = "ListLinkValue";

export default ListLinkValue;
